import { call, take, put }   from 'redux-saga/effects';
import axios                 from 'axios';
import { SET_STUDENTS_INFO } from '../actions';
import mockSudentInfo        from '../utils/mockData/mockStudentInfo'

const endpoint = 'api/getStudentsInfo.php'

type resultType = {
  answers:    string;
  author:     string;
  //grades:     string;
  lessontype: string;
};

const compare = (a: any, b: any) => {
  if ( a.lessontype < b.lessontype ){
    return -1;
  }
  if ( a.lessontype > b.lessontype ){
    return 1;
  }
  return 0;
}

function* getStudentsInfo(): Generator<any,any,any> {
    while(true) {
      try {

        const input = yield take('GET_STUDENTS_INFO_SAGA');
        const { teacherId } = input.payload;

        if (process.env.NODE_ENV === 'development') {
          const payload = mockSudentInfo;
          yield put(SET_STUDENTS_INFO( payload ))
          return
       }

        //yield put(SET_USER_INFO( input.payload ))
  
        const response = yield call( 
          axios.post, 
          endpoint, 
          { teacherId: `${ teacherId }` }
        )
        if (response.data) {

           if(response.data.success) {
              const arr = response.data.result.filter((val: resultType) => {
                return val.answers.length > 0
               }).sort(compare);
  
               const payload = arr;
               yield put(SET_STUDENTS_INFO( payload ))
           }
           else {
            console.log('response  :   ',response.data)
           }
        }
        else {
          console.log('no response - cannot get student info')
        }
      }
      catch (err) {
        console.log('err  :  '+err);
      }
      finally {
        
      }
    }
  }

export default getStudentsInfo;

